import { Assessment } from './assessment-service'

const apiUrl = process.env.REACT_APP_API_URL

export default async function getStudents(classId: number, batch_id: number) {
    const token = localStorage.getItem('token')
    const res = await fetch(`${apiUrl}/students/${classId}/${batch_id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    const response: Response = await res.json()

    response.students.forEach((student) => {
        if (student.student_id === '2343') {
            student.profilePic = 'images/assessment/students/Alannah Lieu.jpeg'
        }
        if (student.student_id === '2242') {
            student.profilePic = 'images/assessment/students/Rose Boots.jpeg'
        }
        if (student.student_id === '2141') {
            student.profilePic =
                'images/assessment/students/Jessica MacDermott.jpeg'
        }
    })

    return response
}

export async function getStudentById(id: string) {
    const token = localStorage.getItem('token')
    const res = await fetch(`${apiUrl}/student/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    const response: Student = await res.json()
    if (response.id === '2343') {
        response.profilePic = '/images/assessment/students/Alannah Lieu.jpeg'
    }
    if (response.id === '2242') {
        response.profilePic = '/images/assessment/students/Rose Boots.jpeg'
    }
    if (response.id === '2141') {
        response.profilePic =
            '/images/assessment/students/Jessica MacDermott.jpeg'
    }

    return response
}

export async function removeStudentFromClass(
    classId: number,
    studentId: string
) {
    const token = localStorage.getItem('token')

    if (!token) {
        throw new Error('User not authenticated')
    }

    const response = await fetch(`${apiUrl}/student/${studentId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    })

    if (!response.ok) {
        throw new Error('Failed to remove student from class')
    }

    return true
}

export async function updateStudent(
    studentId: string,
    data: {
        first_name?: string
        last_name?: string
        student_id?: string
        gender?: string
    }
) {
    const token = localStorage.getItem('token')

    if (!token) {
        throw new Error('User not authenticated')
    }

    const response = await fetch(`${apiUrl}/student/${studentId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    })

    if (!response.ok) {
        throw new Error('Failed to update student')
    }

    const updatedStudent: Student = await response.json()
    return updatedStudent
}

export async function addStudent(data: {
    class_id: number
    first_name: string
    last_name: string
    student_id: string
    gender?: string
}) {
    const token = localStorage.getItem('token')

    if (!token) {
        throw new Error('User not authenticated')
    }

    const response = await fetch(`${apiUrl}/student`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    })

    if (!response.ok) {
        throw new Error('Failed to add student')
    }

    const newStudent: Student = await response.json()
    return newStudent
}

interface Response {
    students: Student[]
}

export interface Student {
    id: string
    first_name: string
    last_name: string
    email: string
    student_id: string
    gender: string
    class: string
    class_name: string
    assessments: Assessment[]
    profilePic: string
}
